@let selectionMode = (selection.selectionMode$ | async) ?? false; @let selected
= (selection.selection$ | async) ?? [];
<div
  class="mb-2 flex flex-wrap items-center gap-1 text-xs text-grey dark:text-lightGrey"
>
  <button
    type="button"
    class="shrink-0 underline decoration-dotted underline-offset-2"
    [attr.aria-pressed]="selectionMode"
    [disabled]="selection.isBusy"
    (click)="selectionMode ? selection.clear() : selection.enter()"
  >
    {{
      (selectionMode
        ? "CATALOG_SEARCH_FINISH_SELECTION"
        : "CATALOG_SEARCH_SELECT_WORKS"
      ) | translate
    }}
  </button>
  @if (selectionMode) {
  <span aria-hidden="true">&bull;</span>
  <span class="min-w-0 italic">{{ "WORK_SELECTION_HELP" | translate }}</span>
  }
</div>
<div
  class="cards-list grid [--g:clamp(18px,2vw,30px)] gap-[var(--g)] [grid-template-columns:repeat(auto-fill,minmax(min(clamp(146px,9vw,190px),calc((100%_-_var(--g))/2)),1fr))]"
  [class.pb-10]="selected.length > 0"
>
  @for (work of works; track work.type + ':' + work._id) {
  <app-work-card
    [item]="work"
    [type]="work.type"
    [user]="user"
    [isMobile]="isMobile"
    [catalogSearch]="true"
    [modalNavigationContext]="modalNavigationContext"
    [dimUnowned]="false"
    [hasMultipleTypes]="hasMultipleTypes"
    [selectionEligible]="!!work._id"
    [selectionMode]="selectionMode"
    [selected]="selection.isSelected(work)"
    (selectionToggled)="selection.toggle($event, works)"
  />
  }
</div>
@if (active) {
<app-work-selection-actions
  [selection]="selected"
  [user]="user"
  [isMobile]="isMobile"
  [canRemove]="libraryOnly"
  actionsModalId="catalog_selection_actions"
  removeModalId="catalog_selection_remove"
  (successes)="onBulkSuccess($event)"
  (clearRequested)="selection.clear()"
  (busyChanged)="selection.setBusy($event)"
/>
}
